<template>
  <div class="PostitOnContent">
    <div class="wrapper" :style="{'height': `${height}px`}">
      <div class="content">
        <slot name="content"></slot>
      </div>
      <div class="postit">
        <slot name="postit"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  import imagesLoaded from "imagesloaded";

  export default {
    name: 'PostitOnImage',
    data() {
      return {
        height: null
      };
    },
    watch: {
      $viewportWidth: {
        handler(newVal, oldVal) {
          if (newVal != oldVal) {
            this.getHeight();
          }
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        imagesLoaded(this.$el, () => {
          this.getHeight();
        })
      })
    },
    methods: {
      getHeight() {
        this.height = this.$el.querySelector('.postit').offsetHeight > this.$el.querySelector('.content').offsetHeight ? this.$el.querySelector('.postit').offsetHeight : this.$el.querySelector('.content').offsetHeight;
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "~$scss/variables";

  $layout-switch: $bootstrap-md;

  .PostitOnContent {
    width: 100%;

    .wrapper {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;

      @media (max-width: $layout-switch - 1px) {
        height: auto !important;
      }

      @media (min-width: $layout-switch) {
        justify-content: flex-start;
      }

      .content {
        flex: 0 0 100%;
        max-width: 100%;

        @media (min-width: $layout-switch) {
          flex: 0 0 70%;
          max-width: 70%;
        }
      }

      .postit {
        margin-top: -40px;
        flex: 0 0 89%;
        max-width: 89%;
        background-color: $color-white;
        padding: 34px 30px;
        box-shadow: 0 5px 10px rgba($color-dark, 0.1);

        @media (min-width: $layout-switch) {
          margin-top: 0;
          position: absolute;
          width: 40%;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          padding: 56px 50px;
        }
      }
    }

    // Reverse theme (content on the right)
    &.reverse {
      .wrapper {
        @media (min-width: $layout-switch) {
          justify-content: flex-end;
        }

        .postit {
          @media (min-width: $layout-switch) {
            right: auto;
            left: 0;
          }
        }
      }
    }

    // postit-on-top-mobile
    &.postit-on-top-mobile {
      .wrapper {
        .content {
          @media (max-width: $layout-switch - 1px) {
            order: 1;
            z-index: 0;
            margin-top: -40px;
          }
        }

        .postit {
          @media (max-width: $layout-switch - 1px) {
            order: 0;
            z-index: 1;
            margin-top: 0;
          }
        }
      }
    }

    &.chained {
      padding: 40px 0;

      &:nth-child(even) {
        .wrapper {
          @media (min-width: $layout-switch) {
            justify-content: flex-end;
          }

          .postit {
            @media (min-width: $layout-switch) {
              right: auto;
              left: 0;
            }
          }
        }
      }
    }
  }
</style>
